import {z} from '@hono/zod-openapi';

export const getHondaRecallsByVinRequestSchema = z
  .object({
    vin: z
      .string()
      .trim()
      .toUpperCase()
      .regex(/^[A-HJ-NPR-Z0-9]{17}$/)
      .openapi({example: 'SHHEU87401U008156'}),
  })
  .openapi('GetHondaRecallsByVinRequest');

export type GetHondaRecallsByVinRequest = z.infer<typeof getHondaRecallsByVinRequestSchema>;
